import React from "react";
import {
  Shield,
  TrendingUp,
  Zap,
  Users,
  Globe,
  Book,
  Lock,
  Headphones,
  Smartphone,
} from "lucide-react";

function FeatureCard({ icon, title, description }) {
  return (
    <div className="bg-white rounded-xl shadow-lg shadow-slate-100 p-8 transition-all duration-300 hover:shadow-xl hover:shadow-slate-200 hover:-translate-y-1">
      <div className="text-blue-600 mb-6 flex justify-center">
        <div className="bg-blue-100 rounded-full p-4">
          {React.cloneElement(icon, { size: 36 })}
        </div>
      </div>
      <h3 className="text-xl font-semibold mb-4 text-center">{title}</h3>
      <p className="text-gray-600 text-center">{description}</p>
    </div>
  );
}

function Features() {
  const features = [
    {
      icon: <Shield />,
      title: "Secure Investments",
      description:
        "Your investments are protected with state-of-the-art security measures and cold storage technology.",
    },
    {
      icon: <TrendingUp />,
      title: "Advanced Market Analysis",
      description:
        "Access real-time market data and AI-powered insights to make informed investment decisions.",
    },
    {
      icon: <Zap />,
      title: "Instant Transactions",
      description:
        "Experience lightning-fast transactions with our cutting-edge blockchain technology and optimized network.",
    },
    {
      icon: <Users />,
      title: "Community-Driven",
      description:
        "Join a thriving community of investors, share strategies, and learn from experienced traders.",
    },
    {
      icon: <Globe />,
      title: "Global Accessibility",
      description:
        "Trade cryptocurrencies from anywhere in the world with our user-friendly platform available in multiple languages.",
    },
    {
      icon: <Book />,
      title: "Educational Resources",
      description:
        "Access a wealth of educational content, including tutorials, webinars, and market reports to enhance your trading skills.",
    },
    {
      icon: <Lock />,
      title: "Regulatory Compliance",
      description:
        "Rest easy knowing we adhere to strict regulatory standards and implement robust KYC and AML procedures.",
    },
    {
      icon: <Headphones />,
      title: "24/7 Support",
      description:
        "Our dedicated support team is available round the clock to assist you with any questions or concerns.",
    },
    {
      icon: <Smartphone />,
      title: "Mobile Trading",
      description:
        "Trade on-the-go with our powerful mobile app, available for both iOS and Android devices.",
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-gray-900">
            Why Choose CryptoInvest
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the future of cryptocurrency trading with our
            cutting-edge platform designed to empower investors of all levels.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
        <div className="mt-16 text-center">
          <a
            href="/"
            className="inline-block bg-blue-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg"
          >
            Start Investing Now
          </a>
        </div>
      </div>
    </section>
  );
}

export default Features;